var homeAnimation = {
  init: function() {
    // if (Foundation.MediaQuery.only('small')) {
    //   var introTextHeight = 0;
    //   var $introTextboxes = $('.intro-title, .intro-subtitle');
    //   $introTextboxes.each(function() {
    //     introTextHeight = Math.max(introTextHeight,$(this).outerHeight());
    //   });  
    //   $introTextboxes.height(introTextHeight);
    // }
    gsap.registerPlugin(ScrollTrigger);
    gsap.timeline({
      scrollTrigger: {
        trigger: "#intro",
        start: 'top top',
        toggleActions: "play none reverse reverse",
        end: 'bottom+=200% top',
        scrub: true,
        pin: true,
      }
    })
      .add('introanim')
      .to('section#intro > .intro-animation-container', {autoAlpha: 1}, 'introanim')
      .to('#hero > *', {autoAlpha: 0}, 'introanim')
      .to('section#intro .intro-title', {autoAlpha: 1})
      .to('section#intro .intro-subtitle', {autoAlpha: 1, delay: -0.2})
    ;
    var aboutAnim = gsap.timeline({
      scrollTrigger: {
        trigger: "#about",
        start: 'top-='+($header.outerHeight())+'px top',
        toggleActions: "play none none none",
        end: 'bottom top',
        scrub: false,
        pin: false,
        once: true,
      }
    });
    if (Foundation.MediaQuery.is('medium')) {
      aboutAnim
      .to('section#about .vismis-image', {autoAlpha: 1, duration: 0.5})
      .to('section#about .vision-container', {autoAlpha: 1, delay: -0.1, duration: 0.25})
      .to('section#about .mission-container', {autoAlpha: 1, duration: 0.25})
      .to('section#about .about-bottom', {autoAlpha: 1, duration: 0.25})
      ;
    } else {
      aboutAnim
      .to('section#about .vision-container', {autoAlpha: 1, duration: 0.25})
      .to('section#about .mission-container', {autoAlpha: 1, delay: 0.1, duration: 0.25})
      .to('section#about .vismis-image', {autoAlpha: 1, delay: 0.1, duration: 0.25})
      .to('section#about .about-bottom', {autoAlpha: 1, delay: 0.1, duration: 0.25})
    }
  }
}

jQuery(document).ready(function($) {
  if ($('body.home').length > 0) {
    homeAnimation.init();
    var $newsImageCarousel = $('.news-image-carousel');
    $newsImageCarousel.flickity({
      cellSelector: '.carousel-cell',
      cellAlign: 'left',
      pageDots: false,
      fade: true,
      wrapAround: true,
      freeScroll: false,
      prevNextButtons: false,
      draggable: false,
    });
    var $newsItemsCarousel = $('.news-items-carousel');
    $newsItemsCarousel
      .on('select.flickity', function(event, index) {
        $newsImageCarousel.flickity('select', index);
      });
    $newsItemsCarousel
      .flickity({
        cellSelector: '.carousel-cell',
        cellAlign: 'left',
        pageDots: true,
        wrapAround: true,
        freeScroll: false,
        prevNextButtons: true,
        draggable: true,
        arrowShape: handlerBlocks.globalCarouselArrow
      });
  }
});
